import { useData } from "./hooks/data"
import { useCardArea } from "./hooks/useCardArea"
import { buildListaEsperaSlides } from "./utils/slideBuilders"
import CarouselGroup from "./components/carousel-group"
import NoticesSection from "./components/notices-section/NoticesSection"
import Turno from "./components/turno/Turno"
import DisponibilidadProvider from "./providers/DisponibilidadProvider"
import "./Disponibilidad.css"

function ListaEsperaContent(): JSX.Element {
    const { ref: cardSectionRef, area: cardArea } = useCardArea()
    const { loading, logo, img_promo_horizontal, img_promo_vertical, escala_cards, lista_espera, folio_turn, folio_anuncio, avisos, pie_pagina } = useData(cardArea)

    const slides = buildListaEsperaSlides({
        listaEspera: lista_espera,
        escala: escala_cards,
        showEmptyState: true,
    })

    return (
        <div className="disp__screen">
            <div className="disp__content">
                <div className="disp__card-section" ref={cardSectionRef}>
                    <CarouselGroup>{slides}</CarouselGroup>
                    {pie_pagina && <p className="disp__pie-pagina">{pie_pagina}</p>}
                </div>

                <NoticesSection
                    logo={logo}
                    loading={loading}
                    imgPromoH={img_promo_horizontal}
                    imgPromoV={img_promo_vertical}
                    showListaEsperaTitle={true}
                    folioTurn={folio_turn}
                    avisos={avisos}
                />

                <Turno 
                    folioTurno={folio_anuncio}
                    size="large"
                    showDuration={10000}
                    isModal={true}
                    ready={!loading}
                >
                    <span>Pregunta al personal por tu habitación.</span>
                </Turno>
            </div>
        </div>
    )
}

function ListaEspera(): JSX.Element {
    return (
        <DisponibilidadProvider>
            <ListaEsperaContent />
        </DisponibilidadProvider>
    )
}

export default ListaEspera